export default "__VITE_ASSET__c6743e82__"